export const Datagrid = {
  list: function () {
    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery("#datagrid-list-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      initComplete: function () {
        DataTablesHelper.setAutoComplete(jQuery('#datagrid-list'));
      },
      pageLength: 20,
      autoWidth: false,
      columnDefs: [
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return jQuery("#datagrid-name-template").html().replace("__label__", data.label).replace("__href__", data.href);
            } else {
              return data.label;
            }
          },
          targets: [0],
        },
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return jQuery("#datagrid-description-template").html().replace("__label__", data.label?.replaceAll("\n", '<br>') || '-');
            } else {
              return data.label;
            }
          },
          targets: [1],
        },
        {
          targets: [-1],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: function () {
        ActionJS.Datagrid.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var table = jQuery("#datagrid-list");
    table.DataTable(options);
  },
  general_list: function () {
    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery("#datagrid-list-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      initComplete: function () {
        DataTablesHelper.setAutoComplete(jQuery('#datagrid-list'));
      },
      columnDefs: [
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return jQuery("#datagrid-name-template").html().replace("__label__", data.label).replace("__href__", data.href);
            } else {
              return data.label;
            }
          },
          targets: [0],
        },
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return jQuery("#datagrid-description-template").html().replace("__label__", data.label?.replaceAll("\n", '<br>') || '-');
            } else {
              return data.label;
            }
          },
          targets: [1],
        },
        {
          targets: [-1],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: function () {
        ActionJS.Datagrid.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var table = jQuery("#datagrid-list");
    table.DataTable(options);
  },

  general_list_schema: function () {
    this.general_list()
  },

  priv: {
    bindEvent: function () {
      jQuery(".datagrid-clone-link, .datagrid-toggle_schema-link, .datagrid-delete-link, .datagrid-mark_as_partitioned-link")
        .off("click")
        .on("click", function (e) {
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data("confirm")) {
            c = confirm(jQuery(this).data("confirm"));
          }
          if (c) {
            jQuery
              .ajax({
                url: jQuery(this).attr("href"),
                method: jQuery(this).attr('data-method'),
                headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content") },
              })
              .done(function (d) {
                Turbo.visit(window.location.href);
              })
              .fail(function (e) {
                alert((((e.responseJSON || {}).id || [])[0] || {}).message || I18n.t("unexpected_error"));
              });
          }
          e.preventDefault();
        });
    },
  },
};
